import { updateSubUserAttribute } from "../../../../../modules/account/views/subUser/redux/actions";
import { validateJsonObject } from "../../../../data/Helpers";

export class USER {
    execute = (data, state, dispatch) => {
        let user = data?.user ? validateJsonObject(data?.user): null;
        dispatch(updateSubUserAttribute(user))
        return [false, {}]
    };
}